import React from "react";
import "./Invalidepage.css";

const Non_page_404 = () => {
  return (
    <div className="not-found-container">
      <h1 className="error-code">404</h1>
      <p className="error-message">Oops! The page you're looking for doesn't exist.</p>
    </div>
  );
};

export default Non_page_404;
